import * as firebase2 from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyCs8hcyJk32wMw4MxZuyO3trhebmPBlljY",
    authDomain: "its-the-end.firebaseapp.com",
    databaseURL: "https://its-the-end.firebaseio.com",
    projectId: "its-the-end",
    storageBucket: "its-the-end.appspot.com",
    messagingSenderId: "837942680284",
    appId: "1:837942680284:web:5416d2a3684455ac2b3219",
    measurementId: "G-ZBJ15KXXF0"
};
// Initialize Firebase
firebase2.initializeApp(firebaseConfig);

export default {
    auth: firebase2.auth(),
    db: firebase2.database(),
    login() {
        const provider = new firebase2.auth.GoogleAuthProvider();
        firebase2.auth().signInWithPopup(provider)
            .then(function(result) {
                console.log(result);
            })
            .catch(function(error){
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.email;
                const credential = error.credential;
                console.log(errorCode, errorMessage, email, credential);
            })
    },
    logout() {
        firebase2.auth().signOut()
            .then(function() {})
            .catch(function(error) {
                console.log(error)});
    }
}